import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Clock } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../mock/mockData';
import { DesktopNav } from './header/DesktopNav';
import { MobileMenu } from './header/MobileMenu';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => {
    if (path === '/mehsullar') return location.pathname.startsWith('/mehsullar');
    if (path === '/haqqimizda') return location.pathname.startsWith('/haqqimizda');
    return location.pathname === path;
  };

  return (
    <>
      {/* Top Bar */}
      <div className="hidden md:block bg-blue-900 text-white text-sm">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between py-3">
            <div className="flex items-center space-x-6">
              <a href={`tel:${companyInfo.phones[0].replace(/\s/g, '')}`} className="flex items-center space-x-2 hover:text-blue-200 transition-colors" data-testid="topbar-phone">
                <Phone className="h-4 w-4" />
                <span>{companyInfo.phones[0]}</span>
              </a>
            </div>
            <div className="flex items-center space-x-2 text-blue-100">
              <Clock className="h-4 w-4" />
              <span>B.e - Cümə: 09:00 - 18:00</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <nav className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" aria-label="Top">
          <div className="flex w-full items-center justify-between py-4">
            <div className="flex items-center">
              <Link to="/" className="flex items-center gap-2.5 sm:gap-3" data-testid="header-logo">
                <img src="/logo-idk.png" alt="İDK" className="h-8 sm:h-9 w-auto" />
                <span className="block h-7 sm:h-8 w-px bg-gray-200"></span>
                <span className="flex flex-col justify-center leading-snug">
                  <span className="text-[12px] sm:text-[13px] font-semibold text-gray-600 tracking-wide">İnkişafa Dəstək</span>
                  <span className="text-[12px] sm:text-[13px] font-medium text-gray-400 tracking-wide">Kreditləri</span>
                </span>
              </Link>
            </div>

            <DesktopNav isActive={isActive} />

            <div className="flex lg:hidden">
              <Button
                variant="ghost"
                size="icon"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                data-testid="mobile-menu-btn"
              >
                {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
              </Button>
            </div>
          </div>

          {mobileMenuOpen && (
            <MobileMenu isActive={isActive} onClose={() => setMobileMenuOpen(false)} />
          )}
        </nav>
      </header>
    </>
  );
};
